import { getInitials, getAvatarGradient } from '@/lib/format';

interface AvatarCircleProps {
  name: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-xl',
};

export function AvatarCircle({ name, size = 'md' }: AvatarCircleProps) {
  const initials = getInitials(name);
  const bg = getAvatarGradient(name);

  return (
    <div
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center font-bold text-white shrink-0`}
      style={{ background: bg }}
    >
      {initials}
    </div>
  );
}
